<template lang="pug">
.campaign-add
  .form-container.full-width.is-required
    aiq-select(v-model="campaign.value",
              :clearable="true"
              :clear-icon="Icon.CircleCloseFilled",
              :suffix-icon="Icon.CaretBottom"
              placeholder="Select a campaign")
      aiq-option(v-for="item in CampaignList",  :key="item.id", :label="item.name", :value="item.id")
  .form-container.full-width.is-required
    aiq-date-picker.time-picker(v-model="campaign.date" :disabled-date="disableBeforeToday" :clear-icon="Icon.CircleCloseFilled", format="MM/DD/YYYY" :placeholder="$t('settings_tab.campaign_tab.manage.start')")
  .button-area
    aiq-button(type="primary" :disabled="addInProgress" @click="$emit('save', campaign)") {{ $t('global.save') }}
    aiq-button(@click="$emit('cancel')") {{ $t('global.cancel') }}
</template>
<script>
export default {
  name: 'AddCampaign',
  props: {
    CampaignList: {
      type: Array,
      default: () => [],
    },
    addInProgress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      campaign: {
        value: null,
        date: null,
      },
    };
  },
  emits: ['save', 'cancel'],
  methods: {
    disableBeforeToday(time) {
      const todayStart = new Date().setHours(0, 0, 0, 0);
      return time.getTime() < todayStart;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-container {
  margin-top: 20px;
}

.button-area {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

:deep(.el-input.el-input--prefix.el-input--suffix.el-date-editor.el-date-editor--date.time-picker.el-tooltip__trigger.el-tooltip__trigger) {
  width: 100%;
  border-radius: 4px;
}

:deep(.el-date-editor.el-date-editor--date .el-input__wrapper) {
  height: 36px !important;
}
</style>